// extracted by mini-css-extract-plugin
export var box = "_8y-1";
export var checked = "_8y-2";
export var descriptionSpacer = "_8y-9";
export var disabled = "_8y-3";
export var icon = "_8y-6";
export var input = "_8y-0";
export var labelSpacer = "_8y-8";
export var medium = "_8y-5";
export var small = "_8y-4";
export var text = "_8y-7";